import { WhoAmI } from 'containers/Auth_old/selectors';

export const BASE_TITLE_TEMPLATE = '%s | Fountain';
export const BASE_DEFAULT_TITLE = 'Talent at Fountain';

/**
 * The tab title is the one impersonation cue that survives a wall of open
 * tabs, so it leads with the impersonated account.
 *
 * This composes the app's single global `Helmet` title template rather than
 * declaring a second one from the banner: react-helmet lets the
 * later-mounted instance win, and the banner mounts above `App`'s `Helmet`,
 * so a template declared there is discarded on every route.
 */
export function impersonationTitles(whoami?: Partial<WhoAmI>) {
  if (!whoami?.is_impersonating) {
    return {
      titleTemplate: BASE_TITLE_TEMPLATE,
      defaultTitle: BASE_DEFAULT_TITLE,
    };
  }

  const prefix = `[Impersonating ${whoami.account_name}] `;

  return {
    titleTemplate: `${prefix}${BASE_TITLE_TEMPLATE}`,
    defaultTitle: `${prefix}${BASE_DEFAULT_TITLE}`,
  };
}

export default impersonationTitles;
